// extracted by mini-css-extract-plugin
export var menu = "header-module--menu--Tzp5Z";